import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  key: 0,
  class: "card-header"
}
const _hoisted_3 = {
  key: 0,
  class: "card-title"
}
const _hoisted_4 = { class: "card-tools" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  key: 1,
  class: "card-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!!_ctx.$slots.header || $props.title !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          ($props.title)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString($props.title), 1))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "header"),
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "tools")
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (!!_ctx.$slots.footer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "footer")
        ]))
      : _createCommentVNode("", true)
  ]))
}